import { CalendarEventReminder } from '@griply/types';

export const MAX_CALENDAR_EVENT_REMINDERS = 5;

// relative minutes before the event start; 0 = at time of event
export const reminderMinuteOptions = [
  0, 5, 10, 15, 30, 60, 120, 1440, 2880, 10080,
];

export const addCalendarEventReminder = (
  reminders: CalendarEventReminder[],
): CalendarEventReminder[] => {
  if (reminders.length >= MAX_CALENDAR_EVENT_REMINDERS) {
    return reminders;
  }

  const used = reminders.map(({ minutes }) => minutes);
  const nextMinutes =
    reminderMinuteOptions.find((minutes) => !used.includes(minutes)) ??
    reminderMinuteOptions[0];

  return [...reminders, { minutes: nextMinutes }];
};

// Toggling a preset on or off, kept sorted so two identical selections are one value.
// `null` (calendar defaults) toggles as if nothing were selected. Past the cap the provider
// drops the extras server-side, so adding is refused here rather than silently lost.
export const toggleCalendarEventReminder = (
  reminders: CalendarEventReminder[] | null,
  minutes: number,
): CalendarEventReminder[] => {
  const selected = (reminders ?? []).map((reminder) => reminder.minutes);
  const isSelected = selected.includes(minutes);

  if (!isSelected && selected.length >= MAX_CALENDAR_EVENT_REMINDERS) {
    return reminders ?? [];
  }

  const next = isSelected
    ? selected.filter((value) => value !== minutes)
    : [...selected, minutes];

  return next.sort((a, b) => a - b).map((value) => ({ minutes: value }));
};

export const isCalendarEventReminderCapped = (
  reminders: CalendarEventReminder[] | null,
  minutes: number,
): boolean => {
  const selected = (reminders ?? []).map((reminder) => reminder.minutes);

  return (
    !selected.includes(minutes) &&
    selected.length >= MAX_CALENDAR_EVENT_REMINDERS
  );
};

export const setCalendarEventReminderMinutes = (
  reminders: CalendarEventReminder[],
  index: number,
  minutes: number,
): CalendarEventReminder[] =>
  reminders.map((reminder, i) =>
    i === index ? { ...reminder, minutes } : reminder,
  );
